import { TransactionsFilters } from "../filters/lib";

interface CreateTransactionsUrlOptions {
    view?: string;
    scheduleTemplateId?: string;
    transactionId?: number;
}

interface ResolveTransactionDeepLinkFiltersOptions {
    filters?: TransactionsFilters;
    entityIds: number[];
    transactionId?: number;
}

export function resolveTransactionDeepLinkFilters({
    filters,
    entityIds,
    transactionId,
}: ResolveTransactionDeepLinkFiltersOptions): TransactionsFilters | undefined {
    const scopedTransactionId =
        transactionId !== undefined &&
        Number.isInteger(transactionId) &&
        transactionId > 0
            ? transactionId
            : undefined;
    if (!filters && scopedTransactionId === undefined) {
        return;
    }
    return {
        ...filters,
        entityIds: filters?.entityIds ?? entityIds,
        ...(scopedTransactionId !== undefined && {
            transactionIds: [scopedTransactionId],
        }),
    };
}

export function createTransactionsUrl(
    filters: TransactionsFilters,
    options: CreateTransactionsUrlOptions = {},
): string {
    const params: string[] = [];

    if (Object.keys(filters).length > 0) {
        params.push(`filters=${encodeURIComponent(JSON.stringify(filters))}`);
    }
    if (options.view) {
        params.push(`view=${encodeURIComponent(options.view)}`);
    }
    if (options.scheduleTemplateId) {
        params.push(
            `scheduleTemplateId=${encodeURIComponent(options.scheduleTemplateId)}`,
        );
    }
    if (options.transactionId) {
        params.push(`transactionId=${options.transactionId}`);
    }

    return params.length > 0
        ? `/transactions?${params.join("&")}`
        : "/transactions";
}
